import { render, staticRenderFns } from "./DigitalIdCompanyAttorneyModal.vue?vue&type=template&id=fce66948&"
import script from "./DigitalIdCompanyAttorneyModal.vue?vue&type=script&lang=js&"
export * from "./DigitalIdCompanyAttorneyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports